(function () {
  var menu = document.querySelector('[data-cebe-cafe-menu]');
  if (!menu) return;
  var navigation = menu.querySelector('.cebe-cafe-menu__categories');
  if (!navigation) return;
  var list = navigation.querySelector('ul');
  var links = Array.from(navigation.querySelectorAll('a[href^="#menu-"]'));
  var headings = links.map(function (link) {
    return document.getElementById(link.hash.slice(1));
  }).filter(Boolean);
  var activeLink = links[0];
  var scheduled = false;
  function setActive(id, reveal) {
    var next = links.find(function (link) { return link.hash === '#' + id; });
    if (!next) return;
    if (next !== activeLink) {
      links.forEach(function (link) {
        if (link === next) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      activeLink = next;
    }
    if (!reveal || window.matchMedia('(min-width: 1001px)').matches) return;
    var linkRect = next.getBoundingClientRect();
    var listRect = list.getBoundingClientRect();
    if (linkRect.left < listRect.left || linkRect.right > listRect.right) {
      list.scrollLeft += linkRect.left - listRect.left - (listRect.width - linkRect.width) / 2;
    }
  }
  function update() {
    scheduled = false;
    var offset = window.matchMedia('(min-width: 1001px)').matches ? 40 : navigation.getBoundingClientRect().height + 36;
    var current = headings[headings.length - 1];
    for (var index = 0; index < headings.length; index += 1) {
      var heading = headings[index];
      var section = heading.closest('.cebe-cafe-menu__section');
      if (section && section.getBoundingClientRect().bottom > offset) {
        current = heading;
        break;
      }
    }
    if (current) setActive(current.id, !navigation.contains(document.activeElement));
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }
  navigation.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#menu-"]');
    if (!link) return;
    setActive(link.hash.slice(1), true);
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('hashchange', schedule);
  update();
}());

// K915: "Cookie settings" at the end of the menu, like the footer's (sections/cebe-footer.liquid): shown once
// Shopify's banner can open its preferences, then the button opens them.
(function () {
  var button = document.querySelector('[data-cebe-cookie-settings]');
  if (!button) return;
  var line = document.querySelector('[data-cebe-menu-legal]');
  // The line itself is hidden until then, so listen on the always visible end of the menu.
  var area = (line && line.closest('.cebe-cafe-menu__foot')) || line;
  var done = false;
  var tries = 0;
  function banner() {
    var b = window.privacyBanner;
    return b && typeof b.showPreferences === 'function' ? b : null;
  }
  function reveal() {
    if (done) return true;
    if (!banner()) return false;
    var nodes = document.querySelectorAll('[data-cebe-cookie-reveal]');
    for (var i = 0; i < nodes.length; i++) nodes[i].removeAttribute('hidden');
    done = true;
    return true;
  }
  function poll() {
    if (!reveal() && tries < 20) {
      tries++;
      window.setTimeout(poll, 500);
    }
  }
  button.addEventListener('click', function () {
    var b = banner();
    if (b) b.showPreferences();
  });
  if (!reveal()) {
    if (area) {
      area.addEventListener('focusin', reveal);
      area.addEventListener('pointerover', reveal);
    }
    document.addEventListener('visitorConsentCollected', reveal);
    if (document.readyState === 'complete') {
      poll();
    } else {
      window.addEventListener('load', poll);
    }
  }
}());
